import { Link } from "react-router-dom";

const BRANDS = [
  ["CHANEL", "Chanel"],
  ["DIOR", "Dior"],
  ["YVES SAINT LAURENT", "Yves Saint Laurent"],
  ["LANCÔME", "Lancôme"],
  ["GIORGIO ARMANI", "Giorgio Armani"],
  ["VERSACE", "Versace"],
  ["GUCCI", "Gucci"],
  ["HUGO BOSS", "Hugo Boss"],
  ["LACOSTE", "Lacoste"],
  ["ZARA", "Zara"],
];

const Marquee = () => (
  <div className="overflow-hidden border-y border-[#EADFCB] bg-[#F7EEDB]/70 py-4">
    <div className="flex w-max animate-marquee">
      {[...BRANDS, ...BRANDS].map(([label, brand], i) => (
        <span key={i} className="flex items-center whitespace-nowrap font-accent text-sm tracking-[0.35em] text-[#C59B27]">
          <Link
            to={`/marque/${encodeURIComponent(brand)}`}
            data-testid={`marquee-brand-${brand}`}
            className="px-8 transition-colors hover:text-[#FF8A00]"
          >
            {label}
          </Link>
          <span className="text-[#FF8A00]">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
